import t from "../skillTranslations";
import React, {useState, useEffect, useContext} from 'react';
import UserContext from "../context/UserContext";

const Admin = () => {
  const {user} = useContext(UserContext);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isChangingType, setIsChangingType] = useState(false);
  const [skill, setSkill] = useState("");
  const [type, setType] = useState("");
  const types = [
    "additional_licenses",
    "additional_passes",
    "job_type",
    "language",
    "license_type",
    "place_of_work",
    "trailer_type",
    "vehicle",
    "employment_type",
  ];
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
  const handleInputChange = (e) => {
    setSkill(e.target.value);
  };
  const handleOptionChange = (e) => {
    setType(e.target.value);
  };
  const SaveSkill = async () => {
    try {
      const response = await fetch(api_endpoint + "/api/inputs/create", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: skill,
          type: type,
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Data returned:', data);
      // Handle the response data here
    } catch (error) {
      console.error("Error inserting skill:", error);
      // Handle the error appropriately
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(api_endpoint + "/api/users");
        const data = await response.json();
        setUsers(data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching users:", error);
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, [isChangingType]);

  const changeUser = async (userId, field, date) => {
    try {
      setIsChangingType(true);
      const response = await fetch(`${api_endpoint}/api/users/changetype`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, field, date }),
      });
      const data = await response.json();
      console.log("User type changed:", data);
    } catch (error) {
      console.error("Error changing user type:", error);
    } finally {
      setIsChangingType(false);
    }
  };
  if (user && user.type !== 'admin') {
    return <div>Nincs jogosultsága...</div>;
  }
  if (isLoading) {
    return <div>Loading...</div>;
  }
if (user.type === 'admin'){
  return (
    <div className="job-apply-container">
      <h1>_________________</h1>
      <h1>Admin oldal</h1>
      <h2>Felhasználók:</h2>
      <ul style={{marginLeft: -100}}>
        {users.map((u) => (
          <div
            style={{marginBottom: 20, marginRight: 1}}
          >
            {u.name}
            <br></br>
            {u.email}
          <br></br>
            <button  style={{marginBottom: 1, marginRight: 1}} className="custom-button-invert" onClick={() => changeUser(u.id, "type", null)}>            <span style={{ color: "black" }}>
              {u.type ? u.type : "kamionos"}
            </span></button>

            <button  style={{marginBottom: 1, marginRight: 1}} className="custom-button-invert" onClick={() => changeUser(u.id, "db_access", null)}>            <span style={{ color: "black" }}>
             DB hozzáférés: {u.db_access == 1 ? "Igen" : "Nem"}
            </span></button>
            <input
                className="custom-button-invert"
                style={{maxWidth: "230px", marginBottom: 1, marginRight: 1}}
                type="date" 
                value={u.poster_until ? new Date(u.poster_until).toISOString().split('T')[0] : null} 
                onChange={(e) => changeUser(u.id, "poster_until", e.target.value)}
              />
          </div>
        ))}
      </ul>
      <h2>képesítések hozzáadása:</h2>
      <select
        value={type}
        onChange={handleOptionChange}
        className="custom-select"
      >
        <option value="">Válasszon képesség típust</option>
        {types.map((option) => (
          <option key={option} value={option}>
            {t[option]}
          </option>
        ))}
      </select>
      <div className="chip-input-desktop">
        <input
          type="text"
          value={skill}
          onChange={handleInputChange}
          placeholder="Gépeld be az új képesség nevét......"
        />
      </div>
      <button className="custom-button-invert" onClick={SaveSkill}>
        Új képesség mentése
      </button>
    </div>
  );
}}


export default Admin;
